// 使用时间转换插件 moment.js
import moment from 'moment'
moment.locale('zh-cn', {
  week: {
    dow: 1,
  }
});

let stg_language = localStorage.getItem('language')||"ch";
stg_language = 'ch';
export const time_hm = (v) => {
  if (v == 0) return v;
  if (!v) return "";
  if (stg_language == 'ch') {
    return moment(v).format('YYYY-MM-DD HH:mm');
  } else {
    return moment(v).format('DD-MM-YYYY HH:mm');
  }

}

export const time_hms = (v) => {
  if (v == 0) return '-';
  if (!v) return "-";
  if (stg_language == 'ch') {
    return moment(v).format('YYYY-MM-DD HH:mm:ss');
  } else {
    return moment(v).format('DD-MM-YYYY HH:mm:ss');
  }

}